export const Blossom = ({ className = "", style, ...rest }) => (
  <svg aria-hidden="true" viewBox="0 0 24 24" className={className} style={style} {...rest}>
    {[0, 72, 144, 216, 288].map((r) => (
      <ellipse key={r} cx="12" cy="6.5" rx="3.4" ry="5" fill="currentColor" transform={`rotate(${r} 12 12)`} opacity="0.85" />
    ))}
    <circle cx="12" cy="12" r="2.4" fill="rgb(var(--bb-rose-soft))" />
  </svg>
);
